import { Link } from 'react-router-dom';
import { 
  Layers, Grid3X3, Hammer, Square, Scissors, Wrench,
  ArrowRight, CheckCircle, Phone
} from 'lucide-react';
import { Button } from '../components/ui/button';

const services = [
  {
    icon: Layers,
    title: 'Hardwood Flooring Installation',
    description: 'Transform your space with the timeless beauty of hardwood floors. Our expert installers work with solid and engineered hardwood to create stunning, durable floors that add value to your property.',
    features: ['Solid & Engineered Options', 'Multiple Wood Species', 'Custom Staining', 'Professional Sanding & Finishing'],
    image: 'https://images.unsplash.com/photo-1693948568453-a3564f179a84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
  },
  {
    icon: Grid3X3,
    title: 'Vinyl Flooring Installation',
    description: 'Luxury vinyl plank (LVP) and vinyl tile offer the perfect combination of style and practicality. Water-resistant and incredibly durable, vinyl flooring is ideal for high-traffic areas and moisture-prone rooms.',
    features: ['Waterproof Options', 'Wood & Stone Looks', 'Easy Maintenance', 'Budget-Friendly'],
    image: 'https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB2aW55bCUyMGZsb29yaW5nJTIwbW9kZXJuJTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc3Mjc5NDEzM3ww&ixlib=rb-4.1.0&q=85',
  },
  {
    icon: Square,
    title: 'Laminate Flooring Installation',
    description: 'Get the look of hardwood or stone at a fraction of the cost with quality laminate flooring. Our skilled team ensures precise installation for a seamless, professional finish.',
    features: ['Realistic Wood Textures', 'Scratch Resistant', 'Quick Installation', 'Affordable Pricing'],
    image: 'https://images.unsplash.com/photo-1704167674713-649193461719?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
  },
  {
    icon: Hammer,
    title: 'Tile Flooring Installation',
    description: 'From elegant marble to durable porcelain, our tile installation services cover kitchens, bathrooms, entryways, and more. We ensure precise cuts and perfect grout lines every time.',
    features: ['Ceramic & Porcelain', 'Natural Stone Options', 'Custom Patterns', 'Heated Floor Compatible'],
    image: 'https://images.unsplash.com/photo-1762633203398-d4432b5269b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHx0aWxlJTIwZmxvb3JpbmclMjBiYXRocm9vbSUyMGtpdGNoZW4lMjByZW5vdmF0aW9ufGVufDB8fHx8MTc3Mjc5NDEzNHww&ixlib=rb-4.1.0&q=85',
  },
  {
    icon: Scissors,
    title: 'Carpet Installation',
    description: 'Add warmth and comfort to your bedrooms and living spaces with professional carpet installation. We offer a wide selection of styles, textures, and colors to match your décor.',
    features: ['Wide Style Selection', 'Stain-Resistant Options', 'Padding Installation', 'Seam-Free Techniques'],
    image: 'https://images.unsplash.com/photo-1675916008013-3002c56f8c79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
  },
  {
    icon: Wrench,
    title: 'Floor Repair & Replacement',
    description: 'Damaged floors don\'t always need complete replacement. Our repair specialists can fix scratches, water damage, squeaky boards, and worn areas to restore your floors to their original beauty.',
    features: ['Scratch Repair', 'Board Replacement', 'Refinishing Services', 'Water Damage Restoration'],
    image: 'https://images.unsplash.com/photo-1588853326295-d49400a3d085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxoYXJkd29vZCUyMGZsb29yJTIwaW5zdGFsbGF0aW9uJTIwcHJvZmVzc2lvbmFsJTIwd29ya2VyfGVufDB8fHx8MTc3Mjc5NDEzMnww&ixlib=rb-4.1.0&q=85',
  },
];

export const ServicesPage = () => {
  return (
    <main className="pt-20" data-testid="services-page">
      {/* Page Header */}
      <section className="page-header py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <span className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
              Our Services
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-amber-950 font-serif mb-6">
              Professional Flooring Solutions
            </h1>
            <p className="text-lg text-stone-600 leading-relaxed">
              From hardwood to tile, we provide comprehensive flooring installation and repair services for residential and commercial properties throughout Los Angeles.
            </p>
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="py-20 lg:py-28 section-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-20">
            {services.map((service, index) => (
              <div
                key={index}
                className={`grid lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
                data-testid={`service-detail-${index}`}
              >
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center">
                      <service.icon className="w-6 h-6 text-amber-600" />
                    </div>
                    <h2 className="text-2xl sm:text-3xl font-bold text-amber-950 font-serif">
                      {service.title}
                    </h2>
                  </div>
                  <p className="text-stone-600 text-lg leading-relaxed mb-6">
                    {service.description}
                  </p>
                  <ul className="space-y-3 mb-8">
                    {service.features.map((feature, fIndex) => (
                      <li key={fIndex} className="flex items-center gap-3">
                        <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
                        <span className="text-stone-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to="/contact">
                    <Button
                      className="bg-green-700 hover:bg-green-800 text-white rounded-full px-8 py-6 font-semibold"
                      data-testid={`service-cta-${index}`}
                    >
                      Get Free Estimate
                      <ArrowRight className="ml-2 w-5 h-5" />
                    </Button>
                  </Link>
                </div>
                <div className={`img-zoom rounded-2xl overflow-hidden shadow-xl ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-80 lg:h-96 object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 lg:py-28 bg-amber-950">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white font-serif mb-6">
            Ready to Start Your Flooring Project?
          </h2>
          <p className="text-amber-100 text-lg mb-8 max-w-2xl mx-auto">
            Contact us today for a free consultation and estimate. Our team is ready to help you transform your space with beautiful new floors.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button
                className="bg-white text-amber-950 hover:bg-stone-100 rounded-full px-8 py-6 font-semibold"
                data-testid="services-page-cta-estimate"
              >
                Get Free Estimate
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <a href="tel:+18888791244">
              <Button
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-amber-950 rounded-full px-8 py-6 font-semibold"
                data-testid="services-page-cta-call"
              >
                <Phone className="mr-2 w-5 h-5" />
                Call +1-888-879-1244
              </Button>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ServicesPage;
